import BaseOptionsBundle from "%/dynamic-components/render-engine/classes/base-options";
import LayoutGap from "%/dynamic-components/render-engine/options/layout-options/layout-gap";
import VerticalLayoutAlign from "%/dynamic-components/render-engine/options/layout-options/vertical-layout-align";
import VerticalLayoutVerticalAlign from "%/dynamic-components/render-engine/options/layout-options/vertical-layout-vertical-align";
import LayoutDirection from "%/dynamic-components/render-engine/options/layout-options/layout-direction";
import Overflow from "%/dynamic-components/render-engine/options/layout-options/overflow";
import LayoutWidth from "%/dynamic-components/render-engine/options/layout-options/layout-width";
import LayoutHeight from "%/dynamic-components/render-engine/options/layout-options/layout-height";
import { inspectorTools } from "%/dynamic-components/builder-engine/inspector/inspector-tool-map";
import MaxWidth from "%/dynamic-components/render-engine/options/spacing-options/max-width";
import MaxHeight from "%/dynamic-components/render-engine/options/spacing-options/max-height";
import MinHeight from "%/dynamic-components/render-engine/options/spacing-options/min-height";
import MinWidth from "%/dynamic-components/render-engine/options/spacing-options/min-width";
import LayoutWrap from "%/dynamic-components/render-engine/options/layout-options/layout-wrap";

export default class RootLayoutPositionOptions extends BaseOptionsBundle {
  optionTitle = "Layout";
  static optionClassName = "i-dynamic-root-layout-position";
  inspectorToolGroup = "layout";
  static userInterfaceComponent = {
    component: inspectorTools.VERTICAL_POSITION_TOOL_SET,
  };

  constructor(values = {}) {
    super(values, [
      new LayoutWidth({
        "default": "fill",
      }, {
        disable: true,
        message: "Width is not available for root layout",
        force: true,
      }),
      new LayoutHeight({
        "default": "fill",
      }, {
        disable: true,
        message: "Height is not available for root layout",
        force: true,
      }),
      MaxWidth,
      MaxHeight,
      MinHeight,
      MinWidth,
      new LayoutDirection({
        "default": "vertical",
        "hover": "vertical",
      }, {
        disable: true,
        message: "Direction is not available for root layout",
        force: true,
      }),
      new Overflow({
        "default": "auto",
        "hover": "auto",
      }, {
        disable: true,
        message: "Overflow is not available for root layout",
        force: true,
      }),
      VerticalLayoutAlign,
      VerticalLayoutVerticalAlign,
      LayoutGap,
      LayoutWrap,
    ]);
  }
}
